import classNames from "classnames";
import { useMemo } from "react";
import { BaseButton } from "../../../../components/Button/BaseButton.tsx";
import { Icon } from "../../../../components/Icon/Icon.tsx";
import { FAVORITE_TAG_NAME } from "../../constants.ts";
import { showDeletedAssetsStore } from "../../stores/showDeletedAssetsStore.ts";
import { tagsFilterStore } from "../../stores/tagsFilterStore.ts";
import type { Tag } from "../../types.ts";

export const TagsFilterBar = ({ tagsFilter }: { tagsFilter: Tag[] }) => {
  const { selectedTagsFilter } = tagsFilterStore.useState();
  const tagsAndSelectionInformation = useMemo(
    () =>
      tagsFilter
        // Set Favorite at the first position for display purpose
        .filter((tag) => tag.name === FAVORITE_TAG_NAME)
        .concat(tagsFilter.filter((tag) => tag.name !== FAVORITE_TAG_NAME))
        .map((tag) => ({
          isSelected: selectedTagsFilter.some((it) => it.uuid === tag.uuid),
          tag,
        })),
    [tagsFilter, selectedTagsFilter],
  );

  const favoriteTag = tagsAndSelectionInformation.find(
    (tag) => tag.tag.name === FAVORITE_TAG_NAME,
  );

  return (
    <div className="flex-row gap-200 items-center">
      {/* FIXME: Define and use secondary button instead*/}
      <BaseTagFilterButton
        name="All assets"
        onClick={() => {
          tagsFilterStore.resetTagsFilter();
          showDeletedAssetsStore.resetShowDeletedAssets();
        }}
        isSelected={
          selectedTagsFilter.length === 0 &&
          !showDeletedAssetsStore.getState().showDeletedAssets
        }
      />
      {favoriteTag && (
        <BaseTagFilterButton
          name="Favorites"
          icon={
            <Icon
              name="Heart"
              size="sm"
              className={classNames(
                favoriteTag.isSelected
                  ? "fill-error-rest stroke-error-rest"
                  : "fill-surface-primary-rest",
              )}
            />
          }
          isSelected={favoriteTag.isSelected}
          onClick={() => {
            if (!favoriteTag.isSelected) {
              tagsFilterStore.resetTagsFilter();
              tagsFilterStore.addTagToFilter(favoriteTag.tag);
              showDeletedAssetsStore.resetShowDeletedAssets();
            }
          }}
        />
      )}
    </div>
  );
};

export const BaseTagFilterButton = ({
  name,
  isSelected,
  onClick,
  icon,
}: {
  name: string;
  isSelected: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
}) => (
  <div
    className={classNames(
      "flex-row-center gap-150 px-200 py-100 rounded-100 text-center text-primary label-md-semibold",
      isSelected
        ? "bg-surface-primary-active"
        : "hover:bg-surface-primary-hover",
    )}
  >
    <BaseButton onClick={onClick}>
      <div className="flex gap-100">
        {icon}
        {name}
      </div>
    </BaseButton>
  </div>
);
